import { useEffect } from 'react'
import Cropper from './Cropper'
import { useImageCropContext } from './ImageCropProvider'
import { ZoomSlider } from './Sliders'
import Button from 'app/components/Button'
import { closeModal } from 'app/lib/modal'
import { readFile } from 'lib/cropImage'

const LogoModal = ({
  handleDone,
  handleDelete,
  shape,
  aspectRatio,
}: {
  handleDone: () => void
  handleDelete: () => void
  shape?: `round` | `rect`
  aspectRatio?: number
}) => {
  const { image, setImage, setShape, setAspectRatio } = useImageCropContext()

  const handleFileChange = async ({ target: { files } }) => {
    const file = files && files[0]
    const imageDataUrl = (await readFile(file)) as string
    setImage(imageDataUrl)
  }

  useEffect(() => {
    if (shape && setShape) {
      setShape(shape)
    }
  }, [shape])

  useEffect(() => {
    if (aspectRatio && setAspectRatio) {
      setAspectRatio(aspectRatio)
    }
  }, [aspectRatio])

  return (
    <div className="relative w-[480px] text-center">
      <div className="flex flex-col gap-6 p-6">
        <div className="flex flex-col items-start">
          <p className="mt-1 text-body-sm text-default">For best results use a PNG or JPG at least 300 x 100 px</p>
        </div>
        {!!image && (
          <div className="flex justify-center">
            <div className="crop-container relative mb-4 h-[432px] w-[432px]">
              <Cropper />
            </div>
          </div>
        )}
        <div className="flex w-full gap-2">
          {!!image && (
            <Button mode="danger" className="grow" onClick={handleDelete}>
              Delete
            </Button>
          )}
          <Button mode="tertiary" className="grow">
            <label htmlFor="picInput2" className="mb-0 w-full cursor-pointer whitespace-nowrap">
              Upload new picture
            </label>
          </Button>
        </div>

        {!!image && <ZoomSlider className="my-4" />}
        <input type="file" multiple onChange={handleFileChange} className="hidden" id="picInput2" accept="image/*" />
      </div>
      <div className="flex items-center justify-end border-t border-strong p-4">
        <div className="flex gap-2">
          <Button mode="tertiary" onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button mode="primary" onClick={() => handleDone()}>
            Save changes
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LogoModal
